@if (simChoiceInterface) {
    <div>
        <div class="bold-text">Quel type de carte SIM souhaitez-vous commander ?</div>
        <div class="pl-5">
            <input type="radio" id="sim" class="form-check-input" name="sim-choice" value="4"
                   [checked]="simChoiceInterface.simChoice == 4" (click)="updateSimChoice(4)"/>
            <label class="form-check-label" for="sim">
                Une carte SIM triple format (miniSIM / microSIM / nanoSIM), compatible avec tous les téléphones
            </label>
        </div>
        @if (disableEsim != true && ['lacarte'].indexOf(brand) == -1) {
            <div class="pl-5">
                <input type="radio" id="eSim" class="form-check-input" name="sim-choice" value="7"
                       [checked]="simChoiceInterface.simChoice == 7" (click)="updateSimChoice(7)"/>
                <label class="form-check-label" for="eSim">
                    Une eSIM (carte SIM virtuelle)
                </label>
            </div>
        }
        <br/>
        @if (simChoiceInterface.simChoice == 4) {
            <div>
                Ce changement de carte SIM vous sera facturé
                <strong>{{ priceDetails?.price }} @if (priceDetails?.perMonth) {
                    <span>/mois</span>
                }</strong>.
                @if (procedureCode == consts.PROCEDURE_ORDER_SIM_CARD) {
                    <div>
                        <br/>
                        Si votre carte SIM ne fonctionne plus, nous vous invitons à publier un message sur <span
                            class="assistance" (click)="assistance()">notre forum</span> afin que nous puissions
                        déterminer d'où vient le problème.
                    </div>
                }
                <br/><br/>
                <div class="d-flex justify-content-center">
                    <img src="../../../../../assets/images/picto_triple_sim.png">
                </div>
                <br/><br/>
                Carte SIM adaptée à tous les modèles de mobiles
                <br/>
                Partie 1 : Mini SIM / Partie 2 : Micro SIM / Partie 3 : Nano SIM.
            </div>
        }
        @if (simChoiceInterface.simChoice == 7) {
            <div>
                <p>Pour utiliser une eSIM (carte SIM virtuelle), il est nécessaire d'avoir un smartphone compatible.
                    Pour le vérifier, <strong class="bold-text">tapez *#06# sur le clavier de votre mobile : si un numéro EID s’affiche avec vos
                    IMEI, c’est qu’il est compatible eSIM.</strong>
                </p>
                <p>
                    Si vous avez déjà une eSIM  {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}, vous pouvez re-télécharger son QR code (5 fois maximum)
                    dans Lignes > Infos et documents. Si cela ne fonctionne pas, nous vous invitons à nous envoyer
                    un message via le chat.
                </p>
                <p>
                    Ce changement de carte SIM vous sera facturé <strong class="bold-text">10€. Cliquez sur le bouton
                    Valider pour confirmer la commande.</strong>
                </p>
                <p>
                    Vous pourrez activer votre eSIM dans la rubrique Lignes > Gestion de ma ligne sous 24h.
                    Une fois votre eSIM activée, vous pourrez télécharger son QR code dans la rubrique
                    Lignes > Infos et documents.
                </p>
            </div>
        }
    </div>
}
